/*
  @params:
  config: 发起请求配置对象  type: Object
  requestParams: 每次发起请求添加的参数   type: Object
*/

export default function setRequestConfig (config, requestParams = {}) {
  let type = getDataType(config)
  if (type !== 'Object') {
    return false
  }

  for (let key in requestParams) {
    if (requestParams.hasOwnProperty(key)) {
      if (config.method === 'get') {
        let url = config.url
        let regExp = /(\w+)=(\w+)/ig
        let params = {}
        url.replace(regExp, function (match, matchExp1, matchExp2) {
          params[matchExp1] = matchExp2
        })
        if (params.action !== 'uploadQRCode' && params.action !== 'checkCard') {
          if (!config.params) {
            config.params = {}
          }
          config.params[key] = requestParams[key]
        }
      } else if (config.method === 'post') {
        let type = getDataType(config.data)
        console.log(type)
        if (type !== 'FormData') {
          if (!config.data) {
            config.data = ''
          }
          let and = config.data && config.data.length ? '&' : ''
          config.data += `${and}${key}=${requestParams[key]}`
        }
      }
    }
  }
  return config
}

function getDataType (data) {
  return Object.prototype.toString.call(data).replace(/\[object\s|\]/g, '')
}



// WEBPACK FOOTER //
// ./src/utils/setRequestConfig.js